import PixagriApplication from '../../models/PixagriApplications';
import {BaseApiService} from './BaseApiService';

export class BaseReportApiService extends BaseApiService {
  getApplication(): PixagriApplication {
    return PixagriApplication.REPORT_ORCHESTRATOR_API;
  }
}
